import React, { Component } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter } from "reactstrap";
import {
    renderField,
    renderSelectField,
    renderCheckbox,
    required,
    renderTextArea,
    number,
    renderPass, minValue, json
} from "../../../../utils/formValidations.js";
import { Field, reduxForm } from "redux-form";
import { withRouter } from "react-router-dom";

const minValue50 = minValue(50);

class AzureProviderFormTemplate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentProvider: {},
        };
        this.submitApi = this.submitApi.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
    }

    componentDidMount() {
        if (this.props.current_provider) {
            this.props.initialize({
                vm_provider_name: this.props.current_provider.vm_provider_name,
                azure_subscription_id: this.props.current_provider.azure_subscription_id,
                azure_resource_group: this.props.current_provider.azure_resource_group,
                azure_tenant_id: this.props.current_provider.azure_tenant_id,
                azure_client_id: this.props.current_provider.azure_client_id,
                azure_client_secret: this.props.current_provider.azure_client_secret,
                azure_region: this.props.current_provider.azure_region,
                azure_authority: this.props.current_provider.azure_authority,

                vm_provider_config_name: this.props.current_provider.vm_provider_config_name,
                max_instances: this.props.current_provider.max_instances,
                azure_vm_size: this.props.current_provider.azure_vm_size,
                azure_os_disk_type: this.props.current_provider.azure_os_disk_type,
                azure_image_reference: this.props.current_provider.azure_image_reference ? JSON.stringify(this.props.current_provider.azure_image_reference, null, 2) : null,
                azure_network_sg: this.props.current_provider.azure_network_sg,
                azure_subnet: this.props.current_provider.azure_subnet,
                azure_os_disk_size_gb: this.props.current_provider.azure_os_disk_size_gb,
                azure_tags: JSON.stringify(this.props.current_provider.azure_tags, null, 2),
                azure_os_username: this.props.current_provider.azure_os_username,
                azure_os_password: this.props.current_provider.azure_os_password,
                azure_ssh_public_key: this.props.current_provider.azure_ssh_public_key,
                startup_script: this.props.current_provider.startup_script,
                azure_config_override: this.props.current_provider.azure_config_override ? JSON.stringify(this.props.current_provider.azure_config_override, null, 2) : null,
                azure_public_ip: this.props.current_provider.azure_public_ip,
                azure_is_windows: this.props.current_provider.azure_is_windows,
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.current_provider && this.props.current_provider !== nextProps.current_provider) {
            this.props.initialize({
                vm_provider_name: nextProps.current_provider.vm_provider_name,
                azure_subscription_id: nextProps.current_provider.azure_subscription_id,
                azure_resource_group: nextProps.current_provider.azure_resource_group,
                azure_tenant_id: nextProps.current_provider.azure_tenant_id,
                azure_client_id: nextProps.current_provider.azure_client_id,
                azure_client_secret: nextProps.current_provider.azure_client_secret,
                azure_region: nextProps.current_provider.azure_region,
                azure_authority: nextProps.current_provider.azure_authority,

                vm_provider_config_name: nextProps.current_provider.vm_provider_config_name,
                max_instances: nextProps.current_provider.max_instances,
                azure_vm_size: nextProps.current_provider.azure_vm_size,
                azure_os_disk_type: nextProps.current_provider.azure_os_disk_type,
                azure_image_reference: nextProps.current_provider.azure_image_reference ? JSON.stringify(nextProps.current_provider.azure_image_reference, null, 2) : null,
                azure_network_sg: nextProps.current_provider.azure_network_sg,
                azure_subnet: nextProps.current_provider.azure_subnet,
                azure_os_disk_size_gb: nextProps.current_provider.azure_os_disk_size_gb,
                azure_tags: JSON.stringify(nextProps.current_provider.azure_tags, null, 2),
                azure_os_username: nextProps.current_provider.azure_os_username,
                azure_os_password: nextProps.current_provider.azure_os_password,
                azure_ssh_public_key: nextProps.current_provider.azure_ssh_public_key,
                startup_script: nextProps.current_provider.startup_script,
                azure_config_override: nextProps.current_provider.azure_config_override ? JSON.stringify(nextProps.current_provider.azure_config_override, null, 2) : null,
                azure_public_ip: nextProps.current_provider.azure_public_ip,
                azure_is_windows: nextProps.current_provider.azure_is_windows,
            });
        }
    }


    cancelButton() {
        this.props.cancel_button(userData)
    }

    submitApi(userData) {
        userData.vm_provider_name = "azure"
        this.props.submit_api(userData)
    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="vm_provider_config_name" className="requiredasterisk">Name </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="vm_provider_config_name"
                                    id="vm_provider_config_name"
                                    component={renderField}
                                    validate={required}
                                    placeholder="Example Azure Config"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_subscription_id" className="requiredasterisk">Subscription ID</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_subscription_id"
                                    id="azure_subscription_id"
                                    component={renderField}
                                    validate={required}
                                    placeholder="00000000-0000-0000-0000-000000000000"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_resource_group" className="requiredasterisk">Resource Group</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_resource_group"
                                    id="azure_resource_group"
                                    component={renderField}
                                    validate={required}
                                    placeholder="development"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_tenant_id" className="requiredasterisk">Tenant ID</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_tenant_id"
                                    id="azure_tenant_id"
                                    component={renderField}
                                    validate={required}
                                    placeholder="00000000-0000-0000-0000-000000000000"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_client_id" className="requiredasterisk">Client ID</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_client_id"
                                    id="azure_client_id"
                                    component={renderField}
                                    validate={required}
                                    placeholder="00000000-0000-0000-0000-000000000000"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_client_secret" className="requiredasterisk">Client Secret</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="password"
                                    name="azure_client_secret"
                                    id="azure_client_secret"
                                    component={renderPass}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_authority" className="requiredasterisk">Azure Authority</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_authority"
                                    id="azure_authority"
                                    component={renderSelectField}
                                    validate={required}
                                >
                                    <option>Select...</option>
                                    <option value="AZURE_PUBLIC_CLOUD">Azure Public Cloud</option>
                                    <option value="AZURE_GOVERNMENT">Azure Government</option>
                                    <option value="AZURE_CHINA">Azure China</option>
                                    <option value="AZURE_GERMANY">Azure Germany</option>
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_region" className="requiredasterisk">Region</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_region"
                                    id="azure_region"
                                    component={renderField}
                                    validate={required}
                                    placeholder="eastus"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="max_instances" className="requiredasterisk">Max Instances</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="max_instances"
                                    id="max_instances"
                                    component={renderField}
                                    validate={number}
                                    placeholder="10"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_vm_size" className="requiredasterisk">VM Size</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_vm_size"
                                    id="azure_vm_size"
                                    component={renderField}
                                    validate={required}
                                    placeholder="Standard_D2s_v3"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_os_disk_type" className="requiredasterisk">OS Disk Type</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field
                                    name="azure_os_disk_type"
                                    id="azure_os_disk_type"
                                    component={renderField}
                                    validate={required}
                                    placeholder="Premium_LRS"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_os_disk_size_gb" className="requiredasterisk">OS Disk Size (GB)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_os_disk_size_gb"
                                    id="azure_os_disk_size_gb"
                                    component={renderField}
                                    validate={[number, minValue50]}
                                    placeholder="100"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_image_reference" className="requiredasterisk">OS Image Reference (JSON)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="textarea"
                                    name="azure_image_reference"
                                    id="azure_image_reference"
                                    validate={required}
                                    component={renderTextArea}
                                    placeholder='{&#10;"publisher": "canonical",&#10;"offer": "0001-com-ubuntu-server-focal",&#10;"sku": "20_04-lts-gen2",&#10;"version": "latest"&#10;}'
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_is_windows" className="requiredasterisk">Image is Windows</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                    name="azure_is_windows"
                                    id="azure_is_windows"
                                    checked={this.props.azure_is_windows && this.props.current_provider.azure_is_windows}
                                    component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_network_sg" className="requiredasterisk">Network Security Group</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="azure_network_sg"
                                    id="azure_network_sg"
                                    component={renderField}
                                    validate={required}
                                    placeholder="/subscriptions/00000000-0000-0000-0000-000000000000/resourcegroups/development/providers/Microsoft.Network/networkSecurityGroups/example-nsg"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_subnet" className="requiredasterisk">Subnet</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="azure_subnet"
                                    id="azure_subnet"
                                    component={renderField}
                                    validate={required}
                                    placeholder="/subscriptions/00000000-0000-0000-0000-000000000000/resourceGroups/development/providers/Microsoft.Network/virtualNetworks/development-vnet/subnets/default"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_public_ip" className="requiredasterisk">Assign Public IP</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                    name="azure_public_ip"
                                    id="azure_public_ip"
                                    checked={this.props.current_provider && this.props.current_provider.azure_public_ip}
                                    component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_tags" >Tags (JSON)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="textarea"
                                    name="azure_tags"
                                    id="azure_tags"
                                    component={renderTextArea}
                                    placeholder='{"name":"value"}'
                                    validate={[required, json]}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_os_username" className="requiredasterisk">OS Username</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="azure_os_username"
                                    id="azure_os_username"
                                    component={renderField}
                                    validate={required}
                                    placeholder="testuser"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_os_password" className="requiredasterisk">OS Password</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="password"
                                    name="azure_os_password"
                                    id="azure_os_password"
                                    component={renderPass}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_ssh_public_key" className="requiredasterisk">SSH Public Key</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="textarea"
                                    name="azure_ssh_public_key"
                                    id="azure_ssh_public_key"
                                    component={renderTextArea}
                                    validate={required}
                                    placeholder="ssh-rsa AAAAAAA...."
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="startup_script" className="requiredasterisk whitespacePre">Agent Startup Script</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="textarea"
                                    name="startup_script"
                                    id="startup_script"
                                    component={renderTextArea}
                                    validate={required}
                                    placeholder="#!/bin/bash&#10;..."
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="azure_config_override">Config Override (JSON)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="textarea"
                                    name="azure_config_override"
                                    id="azure_config_override"
                                    component={renderTextArea}
                                    placeholder='{"name" : "value"}'
                                    required={[json,required]}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="button" size="sm"
                            className="cancel-button"
                            color="basic" onClick={() => this.props.cancel_button()}>{this.props.wizard ? 'Previous' : 'Cancel'}</Button>
                        <Button type="submit"
                            className="submit-button"
                            size="sm" color="primary">{!this.props.wizard ? 'Submit' : this.props.stepCount && this.props.stepCount > 2 ? 'Next' : 'Finish'}</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}


AzureProviderFormTemplate.propTypes = {
    current_provider: Proptypes.object,
    submit_api: Proptypes.func.isRequired,
    handleSubmit: Proptypes.func,
    cancel_button: Proptypes.func,
};


let AzureProviderFormWithRouter = withRouter(AzureProviderFormTemplate);

let AzureProviderForm = connect(state => {

    return {
        vm_provider_configs: state.vm_provider.vm_provider_configs,
    }
},

    dispatch =>
    ({

    }))(AzureProviderFormWithRouter);

export default reduxForm({
    form: "VmProviderForm",
})(AzureProviderForm);
